import { MenuList } from "./menu-list";

interface SidebarProps {
  variant?: "default" | "drawer";
}

export function Sidebar({ variant = "default" }: SidebarProps) {
  return <MenuList variant={variant} />;
}
